<template>
  <tr>
    <td>{{ item.code }}</td>
    <td>{{ item.bill_number }}</td>
  	<td>{{ item.vendor }}</td>
    <td>{{ formatMysqlDate(item.date, 'Do MMM, YYYY') }}</td>
    <td>{{ item.purchase_type == config.purchaseTypes.product ? 'Product' : 'Raw Material' }}</td>
    <td class="text-xs-right">{{ item.grandtotal | roundValue }}</td>
    <td>{{ status }}</td>
    <td class="align-center justify-center layout px-0">
      <v-icon small class="mr-1" color="green" v-if="hasConfirmAndCancelAccess" @click="$emit('confirm', item)">done</v-icon>
      <v-icon small class="mr-1" color="red" v-if="hasConfirmAndCancelAccess" @click="$emit('cancel', item)">clear</v-icon>
      <router-link :to="`/purchase/${item.id}`" v-if="hasEditAccess && isPending" title="Edit Purchase">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
      <router-link :to="`/purchase/view/${item.id}`" title="View Purchase">
        <v-icon small class="mr-1">visibility</v-icon>
      </router-link>
      <a :href="`#/purchase/print/${item.id}`" v-if="isApproved" target="_new" title="Print Purchase" class="hidden-sm-and-down">
        <v-icon small class="mr-1">print</v-icon>
      </a>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'PurchaseListItem' ,
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.purchaseStatus.pending
    },

    isApproved () {
      return this.item.status == this.config.purchaseStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.purchaseStatus.cancelled
    },

    hasConfirmAndCancelAccess () {
      return this.hasAdminPrivilage && this.hasEditAccess && this.isPending
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.purchaseStatus.pending:
          status = "Pending"
        break
        case this.config.purchaseStatus.approved:
          status = "Approved"
        break
        case this.config.purchaseStatus.cancelled:
          status = "Cancelled"
        break
      }
      return status
    }

  },

  watch: {

    
    
  }
}
</script>